import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'
import api from 'api'

const FETCH_REQUEST = 'realhub/service/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/service/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/service/FETCH_FAILURE'
const CREATE_REQUEST = 'realhub/service/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/service/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/service/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/service/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/service/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/service/UPDATE_FAILURE'

// Initial State
const initialState = {
  result: [],
  loaded: false,
  loadedServiceIds: [],
  loading: false,
  creating: false,
  updating: false,
  errors: [],
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loading: true,
    loadedServiceIds: payload.loadedServiceIds,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    loading: false,
    loaded: true,
    errors: [],
    result: payload.result,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    loaded: false,
    loading: false,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload = {}){
  return {
    type: CREATE_SUCCESS,
    result: payload.result,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadServices(options){
  const config = {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
  }

  return (dispatch) => {
    // Set Loading
    dispatch(fetchRequest())

    // Encode Params
    const promise = api('/admin/services.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.SERVICE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        return dispatch(fetchSuccess({ result: normalizedJson.result }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function loadService(service, options){
  return (dispatch, getState) => {
    const {services} = getState()

    // Set Loading
    const loadedServiceIds = services.loadedServiceIds ? services.loadedServiceIds.slice() : []
    if (!loadedServiceIds.includes(services.id)){
      loadedServiceIds.push(services.id)
    }

    dispatch(fetchRequest({ loadedServiceIds }))

    const promise = api(`/admin/services/${service.id}.json`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to result array
        const result = services.result ? services.result.slice() : []
        if (!result.includes(json.id)){
          result.push(json.id)
        }

        const normalizedJson = normalize(json, Schemas.SERVICE)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess({ result }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function createService(service, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      service,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api('/admin/services.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.SERVICE)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess(normalizedJson))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function updateService(service, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      service,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/services/${service.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.SERVICE)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return { ...state, loading: true,}
    case FETCH_SUCCESS:
      return { ...state, loading: false,
        loaded: true,
        result: action.result,
        errors: [],}
    case FETCH_FAILURE:
      return { ...state, loading: false,
        loaded: false,
        errors: action.errors,}
    case CREATE_REQUEST:
      return { ...state, creating: true,}
    case CREATE_SUCCESS:
      return { ...state, creating: false,
        result: action.result,
        errors: [],}
    case CREATE_FAILURE:
      return { ...state, creating: false,
        errors: action.errors,}
    default:
      return state
  }
}
